import { Form, Button } from 'antd'
import { CustomInput } from '../common/custom-input/CustomInput'
import { CloseCircleOutlined } from '@ant-design/icons'
interface IProps {
    form: any
    onChange: (values: any) => void
    onSubmit: (values: any) => void
    spin: boolean
    openForgotPassword: (bool: boolean) => void
    errorBool: boolean
    error: any
}
export const LoginForm = ({ ...props }: IProps) => {
    const {
        form,
        onChange,
        onSubmit,
        spin,
        openForgotPassword,
        errorBool,
        error,
    } = props
    let text = ''
    if (error.response) {
        if (error.response.status === 401)
            text =
                'Nombre de usuario o contraseña incorrectos, por favor vuelve a intentarlo.'
        if (error.response.status === 500) text = 'Error de servidor'
    }
    return (
        <div className='context'>
            <div className='logo'></div>
            <div className='title'>Inicio de sesión</div>
            <div className='subtitle'>
                Inicia sesión con tu email y contraseña.
            </div>
            {errorBool && (
                <div className='errors'>
                    <div className='icon'>
                        <CloseCircleOutlined />
                    </div>
                    <div className='text'>{text}</div>
                </div>
            )}
            <Form
                // {...formItemLayout}
                layout='vertical'
                form={form}
                onValuesChange={onChange}
                onFinish={onSubmit}
                scrollToFirstError>
                <CustomInput name='email' type='email' label='Email' required />
                <CustomInput
                    name='password'
                    type='password'
                    label='Contraseña'
                    required
                />
                <Form.Item>
                    <Button loading={spin} htmlType='submit' type='primary'>
                        Iniciar sesión
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}
